import { render } from "./FeedbackPanel.vue?vue&type=template&id=b3160c10"
import script from "./FeedbackPanel.vue?vue&type=script&lang=js"
export * from "./FeedbackPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__